/**
 * Created by fers on 27.04.16.
 */
 /* global document window */
import { assert } from 'chai';
import { joinedEvaluateExpression } from '../expression/ExpressionBuilder';

/**
 * Function that fills template with real values. template is in format "something {variable} diferrent"
 *
 * @param template
 * @param entityDef
 * @param values
 * @returns {*}
 */
// eslint-disable-next-line max-params
export function fillInTemplate(
	template: string, 
	entityDef: any, 
	allFieldDefs: any[], 
	values: { [key: string]: any }, 
	isPreview: boolean = false
): string | boolean {
    assert.isDefined(entityDef, "entityDef required");
    assert.isDefined(allFieldDefs, "entityDef required");

    if (!template) {
        return template;
    }

    let out = joinedEvaluateExpression(template, (variable: string): any => {
        let fieldDef = allFieldDefs.find((a: any) => a['realId'] === variable);

        if (fieldDef) {
            let value = values[fieldDef['realId']];
            if (value && value !== void 0) {
                return value;
            } else if (isPreview) {
                if (fieldDef['exampleData'] && fieldDef['exampleData'] !== '') {
                    return fieldDef['exampleData'];
                } else if (fieldDef['shortName']) {
                    return fieldDef['shortName'];
                } else {
                    return fieldDef['name'];
                }
            }
        }
    });

    return filterTemplate(out);
}

function filterTemplate(html: string): string | false {
    if (!(typeof window === 'object' && 'document' in window)) {
        return html;
    }

    let el = document.createElement("div");
    el.innerHTML = html; // nosemgrep

    let filledHeaders = Array.from(el.getElementsByClassName("header")).some((element) => {
        return element.innerText && element.innerText.length > 0;
    });
    if (!filledHeaders) {
        return false;
    }

    let filledData = Array.from(el.getElementsByClassName("data")).some((data) => {
        let text = data.innerText.trim() || "";
        return text.length > 0;
    });
    if (!filledData) {
        return html;
    }

    Array.from(el.getElementsByClassName('optional')).forEach((element) => {
        let text = element.innerText.trim() || "";
        if (text.length === 0) {
            element.remove();
        }
    });

    let out = el.innerHTML;
    el.remove();

    return out;
}